// extracted by mini-css-extract-plugin
module.exports = {"columnGray":"dataTable_columnGray__1byG-"};